export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Қайдан"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Қайда"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сома"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Аудару"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Өз шоттары арасында аудару"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Әмиян ішіндегі аударымдар"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жіберуші мен алушының шоттары әртүрлі болуы керек"])}
}